import { css, type SerializedStyles } from '@emotion/react'
import Link from 'next/link'
import type React from 'react'
import { capitalize } from '../../helpers/capitalize'
import { colors } from '../../theme/theme'
import {
  type Principles,
  principles,
  principlesPermalinksReversed,
} from './Principles'

type props = {
  principle: Principles
  className?: string
  styles?: SerializedStyles
}
export const Button: React.FC<props> = ({ className, principle, styles }) => {
  const link = css`
    border: 1px solid ${colors.lightgrey};
    border-radius: 5px;
    flex: 1;
    font-size: 1.1rem;
    font-weight: 400;
    margin: 20px 10px;
    padding: 20px 20px;
    text-decoration: none;

    &:hover {
      background-color: ${colors.background};
    }

    img {
      height: 55px;
      margin-right: 20px;
      min-width: 55px;
    }

    > span {
      white-space: nowrap;
    }
  `
  return (
    <Link
      key={principle}
      href={`/${principlesPermalinksReversed[principle]}`}
      passHref
    >
      <div className={`frc ${className}`} css={[link, styles]}>
        {<img alt={principle} src={principles[principle].src} />}
        <span>{capitalize(principle.replace('Science of ', ''))}</span>
      </div>
    </Link>
  )
}
